module.exports = __webpack_public_path__ + "img/6-2.4bd98c62.jpg";